var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"400px"}},[_c('Table',{attrs:{"data":_vm.list,"columns":_vm.columns,"pages":_vm.pages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }